import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

// Separate messages by category for better organization
const productCategories = {
  foodBeverages: [
    "Milk Powder Full Cream & Low Fat",
    "Whey Milk Powder",
    "Creamer",
    "Black Leaf Tea",
    "Rooibos Leaf Tea",
    "Jams",
    "Golden Syrup",
    "Peanut Butter",
    "Baking Powder",
    "Lentils",
    "Green Split Peas",
    "Kidney Beans",
    "Stock Powders and Granules",
    "Gravy Powders Beef and Chicken",
    "Soup Powders Beef, Chicken, Minestrone and Beef & Onion",
    "Curry Powders Mild, Medium and Hot",
    "Spices BBQ, Chicken and Fish",
    "Mayonnaise",
    "Tomato Sauce",
    "Crushed Garlic",
    "Chillies",
    "Gherkins & Cucumbers",
    "Lemon Juice",
    "Vinegars",
    "Pepper in Grinders",
    "Salt in Grinders",
  ].map((text) => ({ text, color: "#2d6a4f" })),

  cleaning: [
    "Dishwashing Liquid",
    "Bleach",
    "Ammoniated Handy Cleaner",
    "Floor Polymer",
    "Degreaser",
    "Pine Gel",
    "Deo / Urinal Blocks",
    "Pink Hand Soap",
  ].map((text) => ({ text, color: "#d8b113ff" })),

  beverages: [
    "Fruit Juice Flavoured Instant Powder Drinks Vitamin Enriched",
    "Fruit Juice Flavoured Instant Powder Drinks Hypertonic",
    "Fruit Juice Flavoured Concentrates",
    "Coffee Beans and Ground Coffee",
    "Bottled Water",
  ].map((text) => ({ text, color: "#359fb9ff" })),
};

// Combine all categories
const bannerMessages = [
  ...productCategories.foodBeverages,
  ...productCategories.cleaning,
  ...productCategories.beverages,
];

// Separate styles for better maintainability
const styles = {
  banner: {
    width: "100%",
    backgroundColor: "#d2f0e7",
    overflow: "hidden",
    position: "relative",
    py: { xs: 0.5, sm: 1 },
    minHeight: { xs: "20px", sm: "25px" },
  },
  scrollingContent: (duration) => ({
    display: "flex",
    alignItems: "center",
    gap: { xs: 2, sm: 4 },
    width: "max-content",
    animation: `scrollBanner ${duration} linear infinite`,
    "@keyframes scrollBanner": {
      "0%": { transform: "translateX(-50%)" },
      "100%": { transform: "translateX(0)" },
    },
  }),
  messageText: {
    fontWeight: "bold",
    px: { xs: 1, sm: 2 },
    fontSize: { xs: "0.7rem", sm: "0.875rem", md: "1rem" },
    whiteSpace: "nowrap",
  },
};

function Banner() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const duration = isMobile ? "45s" : "60s";

  const renderMessages = () => {
    // Double the messages for seamless loop
    const messages = [...bannerMessages, ...bannerMessages];
    return messages.map((message, index) => (
      <Typography
        key={`message-${index}`}
        variant="body2"
        sx={{ ...styles.messageText, color: message.color }}
      >
        {message.text}
      </Typography>
    ));
  };

  return (
    <Box sx={styles.banner}>
      <Box sx={styles.scrollingContent(duration)}>{renderMessages()}</Box>
    </Box>
  );
}

export default Banner;
